import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import './AuctionDetails.css';
import MasterService from '../../services/MasterService';

const AuctionDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [auctionData, setAuctionData] = useState(null);
    
    // Get auction data from location state or use mock data
    useEffect(() => {
        const data = location?.state?.auctionData;
        if (data) {
            setAuctionData(data);
        }
    }, [location?.state?.auctionData]);
    
    // Use auctionData from state or fallback to mock data
    const displayData = auctionData || {};

    const [vehicleData, setVehicleData] = useState([]);

    // Update vehicleData when auctionData changes
    useEffect(() => {
        if (auctionData && auctionData.selectedVehicles && auctionData.selectedVehicles.length > 0) {
            const vehicles = auctionData.selectedVehicles.map(vehicle => ({
                lead_id: vehicle.lead_id,
                dealer_id: vehicle.dealer_id,
                dealer_name: vehicle.dealer_name,
                make_id: vehicle.make_id,
                make_name: vehicle.make_name,
                model_id: vehicle.model_id,
                model_name: vehicle.model_name,
                variant_id: vehicle.variant_id,
                variant_name: vehicle.variant_name,
                make_year: vehicle.make_year,
                km_driven: vehicle.km_driven,
                deal_price: vehicle.deal_price,
                oto_base_price: vehicle.oto_base_price,
                plate_number: vehicle.plate_number,
                incrementalAmount: vehicle.incremental_amount,
                increment: vehicle.auction_increment_time,
                trigger: vehicle.auction_increment_trigger
            }));
            setVehicleData(vehicles);
        }
    }, [auctionData]);

    const handleInputChange = (index, field, value) => {
        const updatedVehicles = [...vehicleData];
        updatedVehicles[index][field] = value;
        setVehicleData(updatedVehicles);
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            
            // Validate that all required fields are filled
            const invalidVehicles = vehicleData.filter(vehicle => 
                !vehicle.incrementalAmount || 
                !vehicle.deal_price || !vehicle.oto_base_price
            );
            
            if (invalidVehicles.length > 0) {
                toast.error('Please fill all required fields for all vehicles (Incremental amount, Deal Price, OTO Base Price)');
                return;
            }

            // Prepare auction data for API call
            const auctionPayload = {
                ...(displayData.isEditMode && displayData.auctionId && {auction_id: parseInt(displayData.auctionId)}),
                auction_name: displayData.auctionName,
                city: parseInt(displayData.cityId),
                region: parseInt(displayData.regionId),
                start_date: displayData.startDate,
                start_time: displayData.startTime + ':00', // Add seconds
                end_date: displayData.endDate,
                end_time: displayData.endTime + ':00', // Add seconds
                selected_dealers: displayData.selectedBuyers,
                selected_leads: vehicleData.map(vehicle => ({
                    lead_id: vehicle.lead_id,
                    incremental_amount: parseInt(vehicle.incrementalAmount) || 0,
                    auction_increment_time: parseInt(vehicle.increment) || 0,
                    auction_increment_trigger_before: parseInt(vehicle.trigger) || 0,
                    deal_price: parseInt(vehicle.deal_price) || 0,
                    oto_base_price: parseInt(vehicle.oto_base_price) || 0
                }))
            };

            console.log('Saving auction:', auctionPayload);
            
            // Make API call to save auction
            const response = await MasterService.createAuction(auctionPayload);
            
            if (response.data?.status === 200 || response.status === 200) {
                toast.success('Auction saved successfully!');
                navigate('/auction');
            } else {
                toast.error('Failed to save auction');
            }
            
        } catch (error) {
            console.error('Error saving auction:', error);
            toast.error('Failed to save auction');
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        navigate('/auction');
    };

    console.log("***************",location,displayData)

    return (
        <div className="auction-details-container">
            {/* Header */}
            <div className="auction-header auction-heading-test-case">
                <h1>{auctionData?.auctionName || 'Auction Details'}</h1>
               
            </div>

        <div className="auction-datetime auction-date-time-outer">
                    <div className="datetime-field">
                        <label>Start Date & Time:</label>
                        <input
                            type="text"
                            value={`${auctionData?.startDate || ''} ${auctionData?.startTime || ''}`}
                            disabled
                            className="disabled-input"
                        />
                    </div>
                    <div className="datetime-field">
                        <label>End Date & Time:</label>
                        <input
                            type="text"
                            value={`${auctionData?.endDate || ''} ${auctionData?.endTime || ''}`}
                            disabled
                            className="disabled-input"
                        />
                    </div>
                </div>
            {/* Vehicles List */}
            <div className="vehicles-section-list">
                <h2>Vehicle Listing</h2>
                <div className="vehicles-table-container">
                    <table className="vehicles-table-auction">
                        <thead>
                            <tr>
                                <th>Vehicle Name and Information</th>
                                <th>Bid</th>
                                <th>Price</th>
                                {/* <th>Auto Time Increment</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {vehicleData.map((vehicle, index) => (
                                <tr key={vehicle.lead_id}>
                                    <td>
                                        <div className="vehicle-info">
                                            <div className="vehicle-name">
                                                {vehicle.make_name} {vehicle.model_name}
                                            </div>
                                            <div className="vehicle-variant">
                                                {vehicle.variant_name}
                                            </div>
                                            <div className="auction-vehicle-details">
                                                <span>Make Year: {vehicle.make_year}</span> | 
                                                <span>KM Driven: {vehicle.km_driven}</span> | 
                                                <span>Plate Number: {vehicle.plate_number}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <label className="input-label">Incremental amount</label>
                                        <input
                                            type="number"
                                            value={vehicle.incrementalAmount || ''}
                                            onChange={(e) => handleInputChange(index, 'incrementalAmount', e.target.value)}
                                            placeholder="Incremental amount"
                                            className="price-input"
                                        />
                                    </td>
                                    <td>
                                        <div className="price-fields">
                                            <label className="input-label">Oto Base Price</label>
                                            <input
                                                type="number"
                                                value={vehicle.oto_base_price ? Math.round(parseFloat(vehicle.oto_base_price)) : ''}
                                                onChange={(e) => handleInputChange(index, 'oto_base_price', e.target.value)}
                                                placeholder="Oto base price"
                                                className="price-input"
                                            />
                                            <label className="input-label">Deal Price</label>
                                            <input
                                                type="number"
                                                value={vehicle.deal_price ? Math.round(parseFloat(vehicle.deal_price)) : ''}
                                                onChange={(e) => handleInputChange(index, 'deal_price', e.target.value)}
                                                placeholder="Deal price"
                                                className="price-input"
                                            />
                                        </div>
                                    </td>
                                    {/* <td>
                                        <div className="time-increment-fields">
                                            <label className="input-label">Increment</label>
                                            <input
                                                type="number"
                                                value={vehicle.increment || ''}
                                                onChange={(e) => handleInputChange(index, 'increment', e.target.value)}
                                                placeholder="Increment Time"
                                                className="price-input"
                                            />
                                            <label className="input-label">Trigger</label>
                                            <input
                                                type="number"
                                                value={vehicle.trigger || ''}
                                                onChange={(e) => handleInputChange(index, 'trigger', e.target.value)}
                                                placeholder="Trigger (minutes)"
                                                className="price-input"
                                            />
                                        </div>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Save Button */}
            <div className="auction-save-section auction-table-btn">
                <button 
                    className="btn-line"
                    onClick={handleCancel}
                    disabled={loading}
                >
                    Cancel
                </button>
                <button 
                    className="btn-primary"
                    onClick={handleSave}
                    disabled={loading}
                >
                    {loading ? 'Saving...' : 'Save Auction'}
                </button>
            </div>
        </div>
    );
};

export default AuctionDetails;
